export default __webpack_public_path__ + "static/media/entrepreneur.947553de.svg";